export const productNumber = (pnc: string) => {
  if (pnc && pnc.length === 9) {
    return `${pnc.substring(0, 3)} ${pnc.substring(3, 5)} ${pnc.substring(5, 7)}-${pnc.substring(7, 9)}`;
  }
  return pnc;
};
